import React, { useEffect } from 'react'
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import './scss/style.scss'
import globalFunctions from './functions/GlobalFunctions';
import CookieFunctions from './functions/CookieFunctions';
import AppRoutes from './AppRoutes';
import Login from './pages/Login';
import Home from './pages/home';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

export default function App() {
    const nav = useNavigate();
    const loc = useLocation();

    // function to check if the route requires auth
    function requiresAuth(value) {
        for (let i = 0; i < AppRoutes.length; i++) {
            const obj = AppRoutes[i];
            if (obj["path"] === value) {
                if (obj["requireAuth"] === true) {
                    return true;
                } else {
                    return false;
                }
            }
        }
        return false; // Return false if no match is found
    }

    //checks every route change if they are authenticated. redirects to login if not 
    useEffect(() => {
        if (!globalFunctions.checkAuthenticated() && requiresAuth(loc.pathname) && loc.pathname !== '/login') {
            // toast.info(t("timeout"), {
            //     closeButton: true,
            //     autoClose: true,
            //     position: toast.POSITION.TOP_LEFT,
            //     theme: "light"
            // });
            CookieFunctions.logout()

            // Logic to implement redirect to their previous page on login
            // const returnUrl = `${process.env.REACT_APP_REDIRECTURI.slice(0, -1)}${loc.pathname}${loc.search}${loc.hash}`;
            // const redirectUrl = `/login?returnURL=${encodeURI(returnUrl)}`
            // nav(redirectUrl)

            nav("/login")
        } else {
            const myHeaders = new Headers();
            myHeaders.append('Authorization', 'Bearer ' + CookieFunctions.getJWTToken());

            const data = new FormData();
            data.append('route', loc.pathname);

            fetch(`api/User/track`, {
                method: 'POST',
                headers: myHeaders,
                body: data
            })
        }
    }, [nav])

    function routes() {
        if (globalFunctions.checkAuthenticated()) {
            return (
                // Authenticated routes
                <DefaultLayout>
                    <Routes>
                        {AppRoutes.map((route, index) => {
                            const { element, requireAuth, ...rest } = route;
                            return (requireAuth && (route.roles ? route.roles.includes(CookieFunctions.getRole()) : true) && (route.driverType ? route.driverType.includes(CookieFunctions.getDriverType()) : true) && (route.country ? route.country.includes(CookieFunctions.getCountry()) : true) && (route.status ? route.status.includes(CookieFunctions.getStatus()) : true)) && <Route key={index} {...rest} element={element} />;
                        })}
                    </Routes>
                    <Route path="*" element={<Home />} />
                </DefaultLayout>

            );
        } else {
            return (
                // Unathenticated routes
                <Routes>
                    {AppRoutes.map((route, index) => {
                        const { element, requireAuth, ...rest } = route;
                        return !requireAuth && <Route key={index} {...rest} element={element} />;
                    })}
                    <Route path="*" element={<Login />} />
                </Routes>
            )
        }
    }

    return (
        <>
            <ToastContainer
                hideProgressBar={true}
                closeOnClick
                autoClose={10000}
                pauseOnHover
            />
            <AuthenticatedTemplate>
                {routes()}
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
                {routes()}
            </UnauthenticatedTemplate>
        </>
    )

}